/**
 * AddPullContentCommand.js
 *
 * @author Olivier van der Pool for Ranj
 **/
export default class AddPullContentCommand {
    constructor(pullContentManager) {
        this._pullContentManager = pullContentManager;

        this.execute = function(event) {
            this._pullContentManager.addPullContent(event.params.data.content, event.params.data.contentPlayer);
        };
    }
}
